<div class="lg:px-8 xl:px-12">
  <app-horizontal-categories-atom
    [items]="categoryItems"
    (clickCard)="selectCategory($event)"
    [title]="'De quoi avez-vous envie ?'"
    [ngClass]="{ 'hidden lg:block': displayOnDesktop }"
  ></app-horizontal-categories-atom>
</div>
